import "./PropertiesContent.css";
import { Avatar } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ImagesModal from "../ImagesModal/ImagesModal";
// import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// import { QueryTypesense } from "../../../Typesense";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import GetSingleClient from "../../../controllers/clients/GetSingleClient";
// import styles from "./PropertiesContent.module.css";
import SharedModalComponent from "../../../components/User/PropertyDetails/SharedModalComponent/SharedModalComponent";
import SharedPartiesModal from "../SharedPartiesModal/SharedPartiesModal";
import DoneIcon from "@mui/icons-material/Done";
import { stringAvatar } from "../../../helpers/stringAvatar";
import useOnclickOutside from "react-cool-onclickoutside";
import GetSingleUser from "../../../controllers/users/GetSingleUser";
import getSettings from "../../../controllers/settings/getSettings";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import OpenDealsWithProperty from "../../../controllers/properties/OpenDealsWithProperty";
import PhoneForwardedRoundedIcon from "@mui/icons-material/PhoneForwardedRounded";
const PropertiesContent = (
  props
  //   {
  //   // property,
  //   // type,
  //   // CurrencySettings,
  //   // tab,
  //   // sharedParties,
  // }
) => {
  const [property, setProperty] = useState(props.property);
  const {
    sellingPrice,
    rentalPrice,
    id,
    propertyTitle,
    propertySubType,
    name,
    bedrooms,
    bathrooms,
    studyroom,
    address,
    images,
    thumbnail,
    bid,
    landArea,
    landAreaUnit,
    numberOfSharedParties,
    availableForRent,
    propertyStatus,
    availableForSale,
    status,
    sharedParties,
    propertyType,
  } = property;

  // const [sharedParties, setSharedParties] = useState(props.sharedParties);
  //listener for realtime updates()
  useEffect(() => {
    // console.log(
    //   "lanjagul createdAt",
    //   props.property.createdAt,
    //   "modifiedAt",
    //   props.property.modifiedAt,
    //   "now",
    //   (Date.now() / 1000).toString(),
    //   "id:",
    //   props.property.id
    // );
    // const q = query(
    //   collection(db, "properties"),
    //   where(firestore.FieldPath.documentId(), "==", props.property.id),
    //   where("modifiedAt", ">", (Date.now() / 1000).toString())
    // );

    const unsub = onSnapshot(
      doc(db, "properties", props?.property?.id),
      (doc) => {
        const p = { id: doc.id, ...doc.data() };
        console.log("onSnapshot", p);
        // setProperty(p);
      }
    );
    return () => {
      unsub();
    };
  }, []);

  const type = props.type;

  const sharedPartyName =
    sharedParties?.length === 1
      ? sharedParties[0]
      : sharedParties?.length >= 2
      ? sharedParties?.length + " Shared Parties"
      : "";
  const tab = props.tab || "inventory";

  // Modal Start
  const [OpenModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseDetailModal = () => setOpenModal(false);
  // Modal End

  const [Images, setImages] = useState([]);
  const [sharedByModel, setSharedByModel] = useState(false);
  const ref = useOnclickOutside(() => {
    // setSharedByModel(false);
  });

  const [SharedBusinessName, setSharedBusinessName] = useState("");
  const [SharedBusinessPhone, setSharedBusinessPhone] = useState("");
  // const [SharedBusinessData, setSharedBusinessData] = useState({});
  const fetchBusiness = async () => {
    const businessData = await GetSingleClient(bid);
    const { businessName } = businessData;
    // setSharedBusinessData(businessData);
    setSharedBusinessName(businessName || "");

    const user = await GetSingleUser(businessData.uid);
    setSharedBusinessPhone(user.phoneNumber);
  };
  useEffect(() => {
    fetchBusiness();
  }, []);
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);
  // Modal Start
  const [OpenImagesModal, setOpenImagesModal] = useState(false);
  const handleOpenImagesModal = () => setOpenImagesModal(true);
  const handleCloseImagesDetailModal = () => setOpenImagesModal(false);

  // Modal End

  /** Popover Logic */
  const [SearchText, setSearchText] = useState("");

  // Modal Start
  const [OpenSharedPartiesModal, setOpenSharedPartiesModal] = useState(false);
  const handleOpenSharedPartiesModal = () => setOpenSharedPartiesModal(true);
  const handleCloseSharedPartiesModal = () => setOpenSharedPartiesModal(false);

  const [sharedPartiesText, setsharedPartiesText] = useState("");
  useEffect(() => {
    let txt = "";
    if (
      getLocalStorageItem("bid") === property["bid"] &&
      (sharedParties?.length || 0) > 0
    )
      txt = sharedParties?.length + " Shared Parties";
    else if (getLocalStorageItem("bid") !== property["bid"])
      txt = "Shared by Ammar Properties";

    setsharedPartiesText(txt);
    //propertyTitle
  }, []);
  // Modal End

  // useEffect of Open Deals Associated To This Property Start
  const [OpenDeals, setOpenDeals] = useState([]);
  useEffect(() => {
    async function fetchData() {
      const openDeals = await OpenDealsWithProperty(id);
      setOpenDeals(openDeals);
    }
    fetchData();
  }, []);

  const navigate = useNavigate();

  // useEffect of Open Deals Associated To This Property End

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 470) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <Fragment>
      <div
        className={`col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 mb-2
        .row-eq-height ${props.openSearch ? "header-search-property-card" : ""}
         ${props?.isAddDeal ? "w-100" : ""}
        
      `}
      >
        <div
          className="property-card"
          onClick={() => {
            if (!props?.isAddDeal) {
              navigate(
                `/user/properties/${
                  getLocalStorageItem("bid") === bid ? "inventory" : "public"
                }/details/${id}`
              );
              props.setOpenSearch(false);
            }
          }}
        >
          <div className="property-card-top">
            <div className="property-card-left">
              <span
                className={
                  "property-label px-2 " +
                  (propertySubType === "House"
                    ? " property-type-house"
                    : propertySubType === "Flat"
                    ? " property-type-flat "
                    : propertyType === "Plot"
                    ? " property-type-plot "
                    : propertySubType === "Upper Portion" || "Lower Portion"
                    ? " property-type-house-portion"
                    : " property-type-default")
                }
              >
                {propertySubType}
              </span>
              <span
                className={
                  "property-label px-2  mx-1" +
                  (availableForSale
                    ? " property-type-sale"
                    : " property-type-rent")
                }
              >
                {availableForSale ? "Sale" : "Rent"}
              </span>
              <div>
                <h2 className="property-title">
                  {propertyTitle?.length > 20
                    ? propertyTitle.slice(0, 15) + "...."
                    : propertyTitle}
                </h2>
                <p className="property-location">
                  {address?.length > 70
                    ? address.slice(0, 50) + "...."
                    : address}
                </p>
              </div>

              <span className="property-size">
                {landArea} &nbsp;
                {landAreaUnit}
              </span>

              {property["confirm-property"] && (
                <span className="property-confirm-tag">Confirmed Property</span>
              )}
            </div>
            <div className="property-card-right">
              <p className="property-price">
                {mCurrencySettings.currency}
                {`
              ${
                mCurrencySettings.currencyFormat === "numeral"
                  ? rentalPrice > 0
                    ? FormatPriceNumeral(rentalPrice)
                    : FormatPriceNumeral(sellingPrice)
                  : rentalPrice > 0
                  ? FormatPriceVerbal(rentalPrice)
                  : FormatPriceVerbal(sellingPrice)
              }`}
              </p>
              {images && images.length !== 0 && (
                <button
                  className="view-property-images"
                  onClick={(e) => {
                    if (!props?.isAddDeal) {
                      e.stopPropagation();
                      handleOpenImagesModal();
                    }
                  }}
                >
                  <svg
                    width="8"
                    height="9"
                    viewBox="0 0 8 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.20383 3.15H6.77284L4.20383 0.675V3.15ZM0.934184 0H4.67092L7.47347 2.7V8.1C7.47347 8.33869 7.37505 8.56761 7.19986 8.7364C7.02466 8.90518 6.78705 9 6.53929 9H0.934184C0.686423 9 0.44881 8.90518 0.273616 8.7364C0.0984227 8.56761 0 8.33869 0 8.1V0.9C0 0.4005 0.415712 0 0.934184 0ZM0.934184 8.1H6.53929V4.5L4.67092 6.3L3.73674 5.4L0.934184 8.1ZM1.86837 3.15C1.62061 3.15 1.38299 3.24482 1.2078 3.4136C1.03261 3.58239 0.934184 3.81131 0.934184 4.05C0.934184 4.28869 1.03261 4.51761 1.2078 4.6864C1.38299 4.85518 1.62061 4.95 1.86837 4.95C2.11613 4.95 2.35374 4.85518 2.52894 4.6864C2.70413 4.51761 2.80255 4.28869 2.80255 4.05C2.80255 3.81131 2.70413 3.58239 2.52894 3.4136C2.35374 3.24482 2.11613 3.15 1.86837 3.15Z"
                      fill="#4C3CA6"
                    />
                  </svg>
                  View Images {`(${images.length})`}
                </button>
              )}
              {tab !== "public" &&
                getLocalStorageItem("bid") === property["bid"] && (
                  <button
                    className="share-property-btn"
                    onClick={(e) => {
                      if (!props?.isAddDeal) {
                        e.stopPropagation();
                        handleOpenModal();
                      }
                    }}
                  >
                    <svg
                      width="9"
                      height="11"
                      viewBox="0 0 9 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.07143 6.875C6.61725 6.875 6.19981 7.04299 5.87029 7.32392L3.81142 5.94776C3.87239 5.65281 3.87239 5.34717 3.81142 5.05222L5.87029 3.67606C6.19981 3.95701 6.61725 4.125 7.07143 4.125C8.13654 4.125 9 3.20158 9 2.0625C9 0.92342 8.13654 0 7.07143 0C6.00631 0 5.14286 0.92342 5.14286 2.0625C5.14286 2.21629 5.15873 2.36607 5.18858 2.51026L3.12971 3.88642C2.80019 3.60549 2.38275 3.4375 1.92857 3.4375C0.863458 3.4375 0 4.36092 0 5.5C0 6.63908 0.863458 7.5625 1.92857 7.5625C2.38275 7.5625 2.80019 7.39451 3.12971 7.11358L5.18858 8.48974C5.15815 8.63677 5.14282 8.78691 5.14286 8.9375C5.14286 10.0766 6.00631 11 7.07143 11C8.13654 11 9 10.0766 9 8.9375C9 7.79842 8.13654 6.875 7.07143 6.875Z"
                        fill="white"
                      />
                    </svg>
                    Share It
                  </button>
                )}
            </div>
          </div>
          <div className="property-card-bottom">
            <div className="property-card-left">
              {/* Icons */}
              {/* If property is plot do not show any bedrooms,bathrooms etc */}
              {propertyType !== "Plot" ? (
                <>
                  {/* If property type is office then only show washrooms */}
                  {propertySubType === "Office" ? (
                    <>
                      {/* Washrooms */}

                      <div
                        className="mr-2 d-flex align-items-center"
                        style={{
                          marginRight: 20,
                        }}
                      >
                        {/* Change svg for mobile screen */}
                        {isMobile ? (
                          <svg
                            width="15"
                            height="10"
                            viewBox="0 0 8 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.625 3.5H1.25V1.25C1.25 0.974297 1.4743 0.75 1.75 0.75C1.92736 0.75 2.08331 0.842891 2.17211 0.9825C1.91442 1.37636 1.94262 1.91337 2.27895 2.27992C2.2137 2.35356 2.21613 2.46611 2.28662 2.53661L2.46341 2.71339C2.53663 2.78661 2.65534 2.78661 2.72858 2.71339L4.21342 1.22856C4.28664 1.15534 4.28664 1.03662 4.21342 0.963391L4.03664 0.786609C3.96614 0.716109 3.85359 0.713703 3.77995 0.778937C3.4995 0.521609 3.11911 0.444109 2.77717 0.538859C2.55127 0.213547 2.17519 0 1.75 0C1.06075 0 0.5 0.56075 0.5 1.25V3.5H0.375C0.167891 3.5 0 3.66789 0 3.875V4.125C0 4.33211 0.167891 4.5 0.375 4.5H0.5V5C0.5 5.44422 0.693156 5.84327 1 6.11792V6.625C1 6.83211 1.16789 7 1.375 7H1.625C1.83211 7 2 6.83211 2 6.625V6.5H6V6.625C6 6.83211 6.16789 7 6.375 7H6.625C6.83211 7 7 6.83211 7 6.625V6.11792C7.30684 5.84327 7.5 5.44422 7.5 5V4.5H7.625C7.83211 4.5 8 4.33211 8 4.125V3.875C8 3.66789 7.83211 3.5 7.625 3.5Z"
                              fill="#929292"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.2969 6.5H2.34375V2.32143C2.34375 1.80941 2.76431 1.39286 3.28125 1.39286C3.6138 1.39286 3.90621 1.56537 4.07271 1.82464C3.58954 2.5561 3.64242 3.55341 4.27304 4.23414C4.15069 4.3709 4.15523 4.57992 4.28742 4.71085L4.61889 5.03915C4.75617 5.17513 4.97877 5.17513 5.11608 5.03915L7.90017 2.28162C8.03745 2.14564 8.03745 1.92516 7.90017 1.78915L7.5687 1.46085C7.43651 1.32992 7.22549 1.32545 7.08741 1.4466C6.56156 0.968703 5.84833 0.824775 5.2072 1.00074C4.78362 0.396587 4.07848 0 3.28125 0C1.98891 0 0.9375 1.04139 0.9375 2.32143V6.5H0.703125C0.314795 6.5 0 6.8118 0 7.19643V7.66071C0 8.04535 0.314795 8.35714 0.703125 8.35714H0.9375V9.28571C0.9375 10.1107 1.29967 10.8518 1.875 11.3619V12.3036C1.875 12.6882 2.1898 13 2.57812 13H3.04688C3.4352 13 3.75 12.6882 3.75 12.3036V12.0714H11.25V12.3036C11.25 12.6882 11.5648 13 11.9531 13H12.4219C12.8102 13 13.125 12.6882 13.125 12.3036V11.3619C13.7003 10.8518 14.0625 10.1107 14.0625 9.28571V8.35714H14.2969C14.6852 8.35714 15 8.04535 15 7.66071V7.19643C15 6.8118 14.6852 6.5 14.2969 6.5Z"
                              fill="#929292"
                            />
                          </svg>
                        )}

                        <span className="mx-1 bottom-content-lbl-2">
                          {bathrooms}
                        </span>
                      </div>
                    </>
                  ) : // If property type is shop then do not show bedrooms,washrooms etc
                  propertySubType == "Shop" ? (
                    ""
                  ) : (
                    //   Else show all icons
                    <>
                      {/* Bedrooms */}

                      <div
                        className="mr-2
                        d-flex align-items-center
                      "
                        style={{
                          marginRight: 20,
                        }}
                      >
                        {isMobile ? (
                          <svg
                            width="15"
                            height="10"
                            viewBox="0 0 10 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.75 3C3.43922 3 4 2.43922 4 1.75C4 1.06078 3.43922 0.5 2.75 0.5C2.06078 0.5 1.5 1.06078 1.5 1.75C1.5 2.43922 2.06078 3 2.75 3ZM8.25 1H4.75C4.61188 1 4.5 1.11188 4.5 1.25V3.5H1V0.25C1 0.111875 0.888125 0 0.75 0H0.25C0.111875 0 0 0.111875 0 0.25V5.75C0 5.88812 0.111875 6 0.25 6H0.75C0.888125 6 1 5.88812 1 5.75V5H9V5.75C9 5.88812 9.11187 6 9.25 6H9.75C9.88813 6 10 5.88812 10 5.75V2.75C10 1.78344 9.21656 1 8.25 1Z"
                              fill="#929292"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="19"
                            height="11"
                            viewBox="0 0 19 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.225 5.5C6.53452 5.5 7.6 4.4719 7.6 3.20833C7.6 1.94477 6.53452 0.916667 5.225 0.916667C3.91548 0.916667 2.85 1.94477 2.85 3.20833C2.85 4.4719 3.91548 5.5 5.225 5.5ZM15.675 1.83333H9.025C8.76256 1.83333 8.55 2.03844 8.55 2.29167V6.41667H1.9V0.458333C1.9 0.205104 1.68744 0 1.425 0H0.475C0.212562 0 0 0.205104 0 0.458333V10.5417C0 10.7949 0.212562 11 0.475 11H1.425C1.68744 11 1.9 10.7949 1.9 10.5417V9.16667H17.1V10.5417C17.1 10.7949 17.3126 11 17.575 11H18.525C18.7874 11 19 10.7949 19 10.5417V5.04167C19 3.26964 17.5115 1.83333 15.675 1.83333Z"
                              fill="#929292"
                            />
                          </svg>
                        )}

                        <span className="mx-1 bottom-content-lbl-2">
                          {bedrooms}
                        </span>
                      </div>
                      <div
                        className="mr-2
                        d-flex align-items-center
                      "
                        style={{
                          marginRight: 20,
                        }}
                      >
                        {isMobile ? (
                          <svg
                            width="15"
                            height="10"
                            viewBox="0 0 8 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.625 3.5H1.25V1.25C1.25 0.974297 1.4743 0.75 1.75 0.75C1.92736 0.75 2.08331 0.842891 2.17211 0.9825C1.91442 1.37636 1.94262 1.91337 2.27895 2.27992C2.2137 2.35356 2.21613 2.46611 2.28662 2.53661L2.46341 2.71339C2.53663 2.78661 2.65534 2.78661 2.72858 2.71339L4.21342 1.22856C4.28664 1.15534 4.28664 1.03662 4.21342 0.963391L4.03664 0.786609C3.96614 0.716109 3.85359 0.713703 3.77995 0.778937C3.4995 0.521609 3.11911 0.444109 2.77717 0.538859C2.55127 0.213547 2.17519 0 1.75 0C1.06075 0 0.5 0.56075 0.5 1.25V3.5H0.375C0.167891 3.5 0 3.66789 0 3.875V4.125C0 4.33211 0.167891 4.5 0.375 4.5H0.5V5C0.5 5.44422 0.693156 5.84327 1 6.11792V6.625C1 6.83211 1.16789 7 1.375 7H1.625C1.83211 7 2 6.83211 2 6.625V6.5H6V6.625C6 6.83211 6.16789 7 6.375 7H6.625C6.83211 7 7 6.83211 7 6.625V6.11792C7.30684 5.84327 7.5 5.44422 7.5 5V4.5H7.625C7.83211 4.5 8 4.33211 8 4.125V3.875C8 3.66789 7.83211 3.5 7.625 3.5Z"
                              fill="#929292"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="15"
                            height="13"
                            viewBox="0 0 15 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.2969 6.5H2.34375V2.32143C2.34375 1.80941 2.76431 1.39286 3.28125 1.39286C3.6138 1.39286 3.90621 1.56537 4.07271 1.82464C3.58954 2.5561 3.64242 3.55341 4.27304 4.23414C4.15069 4.3709 4.15523 4.57992 4.28742 4.71085L4.61889 5.03915C4.75617 5.17513 4.97877 5.17513 5.11608 5.03915L7.90017 2.28162C8.03745 2.14564 8.03745 1.92516 7.90017 1.78915L7.5687 1.46085C7.43651 1.32992 7.22549 1.32545 7.08741 1.4466C6.56156 0.968703 5.84833 0.824775 5.2072 1.00074C4.78362 0.396587 4.07848 0 3.28125 0C1.98891 0 0.9375 1.04139 0.9375 2.32143V6.5H0.703125C0.314795 6.5 0 6.8118 0 7.19643V7.66071C0 8.04535 0.314795 8.35714 0.703125 8.35714H0.9375V9.28571C0.9375 10.1107 1.29967 10.8518 1.875 11.3619V12.3036C1.875 12.6882 2.1898 13 2.57812 13H3.04688C3.4352 13 3.75 12.6882 3.75 12.3036V12.0714H11.25V12.3036C11.25 12.6882 11.5648 13 11.9531 13H12.4219C12.8102 13 13.125 12.6882 13.125 12.3036V11.3619C13.7003 10.8518 14.0625 10.1107 14.0625 9.28571V8.35714H14.2969C14.6852 8.35714 15 8.04535 15 7.66071V7.19643C15 6.8118 14.6852 6.5 14.2969 6.5Z"
                              fill="#929292"
                            />
                          </svg>
                        )}

                        <span className="mx-1 bottom-content-lbl-2">
                          {bathrooms}
                        </span>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </div>
            <div className="property-card-right">
              <div className="shared-by-container">
                <section className="mr-2">
                  {/* Shared by  */}
                  {tab === "public" ||
                  (tab === "inventory" &&
                    getLocalStorageItem("bid") !== property["bid"] &&
                    SharedBusinessName !== "") ? (
                    <div>
                      <div>
                        <p
                          className="shared-by-text"
                          // onClick={handleOpenSharedPartiesModal}
                        >
                          Shared By
                        </p>
                        <p
                          className="share-party-name-text"
                          onMouseEnter={(e) => {
                            e.stopPropagation();
                            setSharedByModel(true);
                          }}
                        >
                          {`(${SharedBusinessName})`}
                        </p>
                      </div>

                      {/* Hover Card */}
                      {sharedByModel === true && (
                        <div
                          onMouseLeave={() => setSharedByModel(false)}
                          ref={ref}
                          className="custom-popup-model"
                        >
                          <div>
                            <Avatar
                              sx={{ width: 30, height: 30 }}
                              {...stringAvatar(SharedBusinessName)}
                              className="LeadAvatar"
                              id="sharedByAvatar"
                            />
                          </div>

                          <div
                            style={{
                              paddingTop: "13px",
                              paddingBottom: "10px",
                            }}
                          >
                            <p className="custom-paragraph">
                              {" "}
                              {SharedBusinessName}
                            </p>

                            <a href={`tel:${SharedBusinessPhone}`}>
                              {
                                <PhoneForwardedRoundedIcon
                                  style={{
                                    color: "#4C3CA6",
                                  }}
                                />
                              }{" "}
                              <span className="custom-phone-number">
                                {SharedBusinessPhone}
                              </span>{" "}
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <span>Shared </span>
                <span>{`(8 peoples)`}</span> */}
                </section>
                {/* Shared with, shared parties */}
                <section>
                  {tab !== "public" &&
                    (numberOfSharedParties || 0) > 0 &&
                    ((tab === "inventory" &&
                      getLocalStorageItem("bid") === property["bid"]) ||
                      tab === "shared") && (
                      <>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenSharedPartiesModal();
                          }}
                          className="share-with-text"
                        >
                          Shared With
                        </span>
                        <span
                          className="total-share-parties-text"
                          onClick={handleOpenSharedPartiesModal}
                        >
                          {`(${numberOfSharedParties || 0} Shared Parties)`}
                        </span>
                      </>
                    )}
                </section>
              </div>
            </div>
          </div>
        </div>

        <SharedPartiesModal
          OpenSharedPartiesModal={OpenSharedPartiesModal}
          handleCloseSharedPartiesModal={handleCloseSharedPartiesModal}
          property={property}
        />
        <ImagesModal
          isPublic={status === "public"}
          existingSharedParties={sharedParties}
          Images={images}
          OpenImagesModal={OpenImagesModal}
          handleCloseImagesDetailModal={handleCloseImagesDetailModal}
        />

        {/* Modal Start */}
        <SharedModalComponent
          OpenModal={OpenModal}
          handleCloseDetailModal={handleCloseDetailModal}
          propertyID={id}
          property={property}
        />
        {/* Modal End */}
      </div>
    </Fragment>
  );
};

export default PropertiesContent;
